import { graphql } from "~/gql";

export const EXTERNAL_MATTER_FRAGMENT = graphql(/* GraphQL */ `
  fragment ExternalMatterParts on ExternalMatter {
    __typename
    id
    title
    status
    createdAt
    updatedAt
    externalCreatedAt
    externalUpdatedAt
    externalReference
    client {
      id
      name
      externalReference
      type
    }
    organisationalUnit {
      ...OrganisationalUnitParts
    }
    leadFeeEarner {
      ...FeeEarnerParts
    }
    taxStatus
    matter {
      id
    }
    currency {
      id
      code
      symbol
    }
  }
`);
